var map = {
	"./Cadena de frio - Mazana 1,3,9.xlsx": "a9a3",
	"./Fruits/a1.png": "7425",
	"./Fruits/a10.png": "29ee",
	"./Fruits/a11.png": "f925",
	"./Fruits/a12.png": "d9c1",
	"./Fruits/a13.png": "2998",
	"./Fruits/a2.png": "4022",
	"./Fruits/a3.png": "826a",
	"./Fruits/a4.png": "bc2a",
	"./Fruits/a5.png": "d36f",
	"./Fruits/a6.png": "6263",
	"./Fruits/a7.png": "d061",
	"./Fruits/a8.png": "0d62",
	"./Fruits/a9.png": "28e4",
	"./Home.png": "ef86",
	"./IDBoriginal.jpg": "d987",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide1.PNG": "a954",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide10.PNG": "93b0",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide2.PNG": "1abd",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide3.PNG": "68fc",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide4.PNG": "f71f",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide5.PNG": "7582",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide6.PNG": "ee58",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide7.PNG": "a8ac",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide8.PNG": "f374",
	"./Imagenes de Cadena de Frio/Imagenes a colocar/Slide9.PNG": "5f0c",
	"./Imagenes_de_Cadena_de_Frio (1).rar": "3923",
	"./SignDollar.png": "4ffd",
	"./Test.rar": "ec4c",
	"./Test/s1.png": "7d5c",
	"./Test/s10.png": "48ae",
	"./Test/s2.png": "070a",
	"./Test/s3.png": "804b",
	"./Test/s4.png": "6561",
	"./Test/s5.png": "a477",
	"./Test/s6.png": "a7a7",
	"./Test/s7.png": "c69e",
	"./Test/s8.png": "ad6c",
	"./Test/s9.png": "d3d2",
	"./WorkInProgress.png": "eb7b",
	"./almacenesRefrigerados.jpg": "9dfa",
	"./campocosecha.jpg": "1f62",
	"./captura.jpg": "dbcc",
	"./chevron-down.png": "6a70",
	"./costs/Export.png": "32fe",
	"./costs/Import.png": "5bb8",
	"./costs/Maritimo.png": "04c2",
	"./costs/Reefer.png": "5584",
	"./costs/airplane.jpg": "91fd",
	"./costs/boat.png": "72ca",
	"./costs/dolly.png": "01d5",
	"./drag-video.gif": "4dc7",
	"./drag_and_drop_example.gif": "afcc",
	"./excelgif.gif": "60f4",
	"./exportExcel.ico": "96fd",
	"./exportExcel.png": "ea2e",
	"./exportacionUsuarioExterno.jpg": "bbfd",
	"./grid.png": "2973",
	"./grid2.jpg": "59ed",
	"./grid3.jpg": "c3e3",
	"./header-logo-observatory-national.jpg": "8b64",
	"./idb-logo-title-2.jpg": "a8b1",
	"./idb-logo-title-2.png": "57aa",
	"./idb-logo-title.jpg": "310d",
	"./idbHome.png": "80a0",
	"./img-main-2.png": "711b",
	"./img-main2.jpeg": "d66f",
	"./img-page-not-found.png": "088c",
	"./inProgress.jpg": "56ad",
	"./international-airplane.jpg": "4fd6",
	"./international-boat.jpg": "59b6",
	"./logo-bid-1.png": "dac8",
	"./logo-bid-2.png": "81ef",
	"./logo-bid.png": "2b0d",
	"./logo-cost.png": "7407",
	"./logo-idb-1.png": "7898",
	"./logo/only-logo.jpg": "ff1d",
	"./main-img.png": "842f",
	"./matadero.jpg": "3a0c",
	"./new-logo-bid.png": "5f56",
	"./newlogo-idb-1.png": "fa4f",
	"./only-logo.jpg": "4d03",
	"./permiso.png": "06e9",
	"./plane-departure.png": "77b5",
	"./presidencial.png": "9bfb",
	"./procesosIndustriales.jpg": "cd30",
	"./procesosIndustrialesImportacion.jpeg": "f5d4",
	"./s1.png": "5ed2",
	"./s10.png": "a29d",
	"./s11.png": "5296",
	"./s2.png": "8955",
	"./s3.png": "ee1c",
	"./s4.png": "dc70",
	"./s5.png": "6dd6",
	"./s6.png": "c6bb",
	"./s7.png": "2675",
	"./s8.png": "35d8",
	"./s9.png": "e401",
	"./ship.png": "1493",
	"./slide/Imagenes a colocar (1).pptx (9).png": "93a4",
	"./slide/Slide10.PNG": "38b3",
	"./slide/Slide2.PNG": "907e",
	"./slide/Slide3.PNG": "4b1f",
	"./slide/Slide4.PNG": "c86b",
	"./slide/Slide5.PNG": "8190",
	"./slide/Slide6.PNG": "383b",
	"./slide/Slide7.PNG": "512a",
	"./slide/Slide8.PNG": "127e",
	"./slide/Slide9.PNG": "ef20",
	"./temperature-low.jpg": "0a86",
	"./terminal.jpg": "0f9f",
	"./timeline.png": "0282",
	"./tooltip.jpg": "4d7f",
	"./tramite.png": "38fc",
	"./tranporte1.png": "a2bd",
	"./tranporte2.png": "7b17",
	"./transport-international-boat.JPG": "6bdb",
	"./transport-international-boat.PNG": "55ce",
	"./transporte.jpg": "f017",
	"./transporteImportacion.jpg": "a5fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";